/**
 * Vite env access isolated in a single module so the rest of the consent
 * service stays free of `import.meta` syntax. `import.meta` is not valid in
 * CommonJS (which is what Jest uses via babel-jest), so this module is replaced
 * with a test stub under Jest via `moduleNameMapper`.
 */
interface ConsentEnv {
  /**
   * Consent CDN base URL (no `${locale}` placeholder). The locale segment is
   * appended in code by `buildConsentUrl`.
   */
  baseUrl?: string;
  /** Uses local consent fixtures only while running the Vite development app. */
  isDevelopmentLike: boolean;
}

export function getConsentEnv(): ConsentEnv {
  const env = import.meta.env;
  return {
    baseUrl: env?.VITE_CONSENT_URL,
    isDevelopmentLike: env?.DEV === true,
  };
}
